export const chapters = [
  {
    id: 6,
    part: 1,
    englishTitle: "The Preliminaries",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: true,
    parts: [
        {
            englishTitle: "Uchiha Sasuke vs Gōmonjō Yoroi",
            label: "tbd", 
            available: false,
            content: `Content for Uchiha Sasuke vs Gōmonjō Yoroi...`
        },
        {
            englishTitle: "Abumi Zaku vs Aburame Shino",
            label: "tbd", 
            available: false,
            content: `Content for Abumi Zaku vs Aburame Shino...`
        },
        {
            englishTitle: "Kankurō vs Hana Shiore",
            label: "tbd", 
            available: false,
            content: `Content for Kankurō vs Hana Shiore...`
        },
        {
            englishTitle: "Nara Shikamaru vs Tsuchi Kin",
            label: "tbd", 
            available: false,
            content: `Content for Nara Shikamaru vs Tsuchi Kin...`
        },
        {
            englishTitle: "Uzumaki Naruto vs Inuzuka Kiba",
            label: "tbd", 
            available: false,
            content: `Content for Uzumaki Naruto vs Inuzuka Kiba...`
        },
        {
            englishTitle: "Temari vs Tenten",
            label: "tbd",
            available: false, 
            content: `Content for Temari vs Tenten...`
        },
        {
            englishTitle: "Hyūga Neji vs Hyūga Hinata",
            label: "tbd", 
            available: false,
            content: `Content for Hyūga Neji vs Hyūga Hinata...`
        },
        {
            englishTitle: "Rock Lee vs Gaara",
            label: "tbd", 
            available: false,
            content: `Content for Rock Lee vs Gaara...`
        },
        {
            englishTitle: "Kinuta Dosu vs Akimichi Chōji",
            label: "tbd", 
            available: false,
            content: `Content for Kinuta Dosu vs Akimichi Chōji...`
        }
    ]
 }
];